import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SystemSettingService } from '@app/api/systemsettting.service';
import { SystemSettingStore } from '@app/services/change-setting.service';
@Component({
  selector: 'meu-modal-video',
  templateUrl: './modal-video.component.html',
  styleUrls: ['./modal-video.component.scss'],
})
export class ModalVideoComponent implements OnInit {
  linkYtb!: SafeResourceUrl;
  constructor(
    private storeSystem: SystemSettingStore,
    private system: SystemSettingService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.getLink();
  }

  getLink() {
    this.system.apiSystemSettingGet('type==VIDEO').subscribe((res) => {
      if (res.success && res.data.collection.length) {
        const rawUrl = res.data.collection[0].children[0].value;

        const embedUrl = this.toYoutubeEmbed(rawUrl);

        this.linkYtb = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);

        this.cdr.detectChanges();
      }
    });
  }

  private toYoutubeEmbed(url: string): string {
    if (!url) return '';

    // youtu.be/xxxx
    if (url.includes('youtu.be/')) {
      return url.replace('youtu.be/', 'www.youtube.com/embed/');
    }

    // youtube.com/watch?v=xxxx
    const match = url.match(/[?&]v=([^&]+)/);
    if (match && match[1]) {
      return `https://www.youtube.com/embed/${match[1]}`;
    }

    return url; // fallback nếu đã là embed
  }
}
